import session from './session'
import format from 'string-format'

export default {


	listSampleTypes() {
		return session.get('/sample_type/')
	},

	/**
	 * Получить из REST список типов чипов
	 * @returns {AxiosPromise<any>}
	 */
	listChipTypes() {
		return session.get('/ngs_chipType/')
	},

	listNgsSources() {
		return session.get('/ngs_source/')
	},

	update_or_create_defaults(defs, sample_type, chip) {
		defs['chip'] = chip
		defs['sample_type'] = sample_type
		return session.post('/ngs_lib_defaults/update_or_create/', defs)
	},

	get_defaults(which, chip) {
		let measuring = which.measuring ? 'True' : 'False'
		return session.get(
			format('/ngs_lib_defaults/filter_defaults/?panel={0}&lab={1}&sample_type={2}&chip={3}&measuring={4}',
				which.panel, which.lab, which.sample_type, chip, measuring))
	},

	get_checklist(explib_ids) {
		return session.post('/get_check_list/', explib_ids)
	},

	write_to_calc(exps_list) {
		return session.post('ngs_run/write_to_calc/', exps_list)
	},

	checkBuildJS(){
		return session.get('check_build_js/')
	},

	personals_hand_to() {
		return session.get('personal/')
	}
}